import type { ReactNode } from 'react';
import { PlaySessionMatchCompetitivenessEnum } from 'types/generated/client';
import Smiley from 'svg/Smiley';
import classNames from 'styles/utils/classNames';

export const REPEAT_SRC = '/images/players/finder/repeat-icon.svg';
export const TOURNAMENT_SRC = '/images/player-home-v2/search-bar-icons/tournament-gradient.svg';
export const MATCH_PREP_SRC = '/images/players/finder/match-prep.svg';

export const GAME_TYPE_LABEL: Record<PlaySessionMatchCompetitivenessEnum, string> = {
  [PlaySessionMatchCompetitivenessEnum.Casual]: 'Recreational play',
  [PlaySessionMatchCompetitivenessEnum.Match]: 'Competitive',
  [PlaySessionMatchCompetitivenessEnum.Practice]: 'Match preparation',
};

/** Sized by the caller — the cards draw it at 20px, the mobile feed at 16px. */
export const getGameTypeIcon = (
  competitiveness: PlaySessionMatchCompetitivenessEnum,
  className: string,
): ReactNode | null => {
  if (competitiveness === PlaySessionMatchCompetitivenessEnum.Casual) {
    return <Smiley className={className} />;
  }
  if (competitiveness === PlaySessionMatchCompetitivenessEnum.Match) {
    return <img src={TOURNAMENT_SRC} alt="" className={classNames(className, 'object-contain')} />;
  }
  if (competitiveness === PlaySessionMatchCompetitivenessEnum.Practice) {
    return <img src={MATCH_PREP_SRC} alt="" className={classNames(className, 'object-contain')} />;
  }
  return null;
};
